<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">My Account</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Content -->
    <div class="card">
      <div class="card-body pb-1">
        <div class="form-row">
          <div class="form-group col-6">
            <label><b>User Type</b></label>
            <div>{{ userType }}</div>
          </div>
          <div class="form-group col-6">
            <label><b>Name</b></label>
            <div>{{ name }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-6">
            <label><b>Email</b></label>
            <div>{{ email }}</div>
          </div>
          <div class="form-group col-6">
            <label><b>School</b></label>
            <div>{{ schoolName }}</div>
          </div>
        </div>
        <div class="form-row" v-if="userType == userTypeStudent">
          <div class="form-group col-6">
            <label><b>Registration Date</b></label>
            <div>{{ registrationDate }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Content -->
  </div>
</template>

<script>
import config from "../../config.js";
import API from "../../http-common.js";
export default {
  data() {
    return {
      userTypeStudent: config.USERTYPE_STUDENT,
      name: "",
      email: "",
      schoolName: "",
      registrationDate: "",
    };
  },
  computed: {
    userType() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data.UserType;
    },
    token() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data.Token;
    },
  },
  methods: {
    getAccountInfo() {
      this.$store.state.isLoading = true;
      API.common
        .getAccountInfo({ Token: this.token })
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            let user = response.data.data;
            this.name = user.Name;
            this.email = user.Email;
            this.schoolName = user.SchoolName;
            this.registrationDate = user.RegistrationDate;
          } else {
            this.$store.state.isLoading = false;
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },
  created() {
    this.getAccountInfo();
  },
};
</script>

<style scoped>
.form-group label {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/SchoolUser/MyAccount.vue